import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';

export const NfcNotAvailableCard = (props) => {

  return (
    <Card sx={{
        border: '1px solid',
        borderColor: '#d50000',
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
        paddingX: 2,
        boxShadow: "none",
        alignItems: "left",
        justifyContent: "left"
      }}>
      <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
              <ErrorIcon color={"primary"} sx={{fontSize:50, color: '#d50000'}}/>
            </Avatar>
          }
          title="Important information"
          subheader="NFC not available"
          titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
      />
      <CardContent sx={{mt:0, pt:0, pb:0}}>
        <Typography variant="body2" color="text.secondary">
           This app requires an compatible device with Chrome and Android. To exchange data, please open the app on a supported device.
        </Typography>
      </CardContent>
    </Card>
  )
}

export default NfcNotAvailableCard;
